module.exports = __webpack_public_path__ + "img/1.01.thmb.xs.c8a8052d.jpg";